import LTR from "@brand-icons/global/social-kakao/social-kakao-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialKakaoIcon = iconFactory("SocialKakaoIcon", LTR);
